import { CSSProperties, useState } from 'react';
import { ButtonView } from '@vivli/shared/views';
import {
    useActiveUserContext,
    useDataRequestsApiContext,
    useModalApiContext,
    useUsersApiContext,
    useVivliConfigContext,
} from '@vivli/core/infrastructure/context';
import { SignDocumentComponent } from './sign-document.component';

import { finalize, first } from 'rxjs/operators';
import { ISignedDocument } from '@vivli/features/users/infrastructure/interface';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { DTIEsign } from '@vivli/shared/infrastructure/constants';

const buttonStyle: CSSProperties = {
    paddingBottom: 10,
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 10,
    minHeight: 50,
    minWidth: 180,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 45,
};

const documentName = 'VivliTermsOfUseAgreement.html';

export const EsignComponent = () => {
    const [isLoading, setIsLoading] = useState(false);
    const modalService = useModalApiContext();
    const { updateSignedDocuments } = useUsersApiContext();
    const { attachSignatureToRequest } = useDataRequestsApiContext();
    const { dataRequest, updateDataRequest } = useDataRequestContext();
    const { user } = useActiveUserContext();
    const vivliConfig = useVivliConfigContext();

    const handleAttachToDataRequest = (signedDocument: ISignedDocument) => {
        attachSignatureToRequest(dataRequest.id, signedDocument.id)
            .pipe(
                first(),
                finalize(() => modalService.dismiss())
            )
            .subscribe(updateDataRequest);
    };

    const handleError = (error) => {
        modalService.error(`Failed to sign document.
        Please try again or contact support if the problem continues: ${error.message}`);
        modalService.dismiss();
    };

    const handleOnSigned = (signature: string) => {
        updateSignedDocuments(user.userId, documentName, vivliConfig?.termsOfUseAgreement, 'HTML', signature)
            .pipe(first())
            .subscribe(handleAttachToDataRequest, handleError);
    };

    const handleButtonClick = () => {
        setIsLoading(true);
        const modalId = modalService.custom(
            <SignDocumentComponent
                onCancel={() => {
                    modalService.dismiss(modalId);
                    setIsLoading(false);
                }}
                onSigned={handleOnSigned}
            />
        );
    };

    return (
        <div>
            <ButtonView
                style={buttonStyle}
                isLoading={isLoading}
                onClick={handleButtonClick}
                className="vmView_signDocument"
                dataId={DTIEsign.ESignButton}
            >
                Sign Now
            </ButtonView>
        </div>
    );
};
